module.exports = __webpack_public_path__ + "fonts/ZingScriptRustR-Base.0f05b9f3.eot";